import { Preferences } from '@capacitor/preferences';

export const setStorageItem = (key, value) => {
  Preferences.set({ key, value });
};

export const getStorageItem = async (key) => {
  const { value } = await Preferences.get({ key: key });
  return value;
};

export const removeStorageItem = async (key) => {
  await Preferences.remove(key);
};

// export const clearAllStorage = async () => {
//   await Preferences.clear();
// };

export const clearUserAuthStorage = async () => {
  await Promise.all([
    Preferences.remove({ key: 'pubCreds' }),
    Preferences.remove({ key: 'TOKEN' }),
    Preferences.remove({ key: 'REFRESH_TOKEN' }),
    Preferences.remove({ key: 'oAuthState' })
  ]);
};
